import React, {useEffect} from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import {browserHistory} from 'react-router';
import styled from 'styled-components';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import {cats, withShortcuts} from 'app/general/shortcuts/withShortcuts';
import {SEARCH_PAGE} from 'app/urls';
import {gt} from 'app/utils/i18n';

import {CompanyLogo} from './CompanyLogo';
import {NavigationTabs} from './NavigationTabs';
import {NotificationsIcon} from './NotificationsIcon';
import {SPHeaderStructure} from './SPHeaderStructure';
import {UserMenu} from './UserMenu';

import type {WithShortcutsProps} from 'app/general/shortcuts/withShortcuts';

interface Props extends WithShortcutsProps {
  sidebarOpened: boolean;
  onToggleSidebar: () => unknown;
}

export const SPHeader = withShortcuts<Props>({
  key: '/',
  name: () => gt('Go to Search page'),
  category: cats.everywhere,
})(function ({
  enableShortcut,
  sidebarOpened,
  onToggleSidebar,
}: Props): JSX.Element {
  useEffect(() => {
    enableShortcut('/', (e) => {
      e.preventDefault();
      browserHistory.push(SEARCH_PAGE);
    });
  }, []);

  return (
    <SPHeaderStructure
      companyLogo={
        <CompanyLogo
          onToggleSidebar={onToggleSidebar}
          sidebarOpened={sidebarOpened}
        />
      }
    >
      <NavigationTabs />

      <StyledAdditionalOpts className="d-flex flex-grow-1 justify-content-end align-items-stretch">
        <ul className="navbar-nav d-flex">
          <li className="d-flex nav-item">
            <FullHTMLLink
              activeClassName="active"
              className="nav-link big d-flex"
              html_url={SEARCH_PAGE}
            >
              <span className="outer">
                <span className="inner">
                  <i className="fa fa-search" />
                </span>
              </span>
            </FullHTMLLink>
          </li>
        </ul>
        <NotificationsIcon />
        <UserMenu />
      </StyledAdditionalOpts>
    </SPHeaderStructure>
  );
});

const StyledAdditionalOpts = styled.div`
    .nav-link {
        font-size: 1rem;
        color: ${colors.blueGray};
        padding: 0 1rem;

        &.big {
            font-size: 1.2rem;
        }

        &:hover {
            color: #FFF;
        }

        &.active {
            > .outer {
                border-bottom-width: 4px;
            }
        }

        > .outer {
            transition all 100ms;
            display: flex;
            align-items: center;
            border-bottom: 0px solid ${colors.lightLinkBlue};
        }

    }
`;
